import _ from 'underscore'
import Cache from 'root/cache';
import Collection_Base from 'collection/base';
import Model_Feedback from 'model/feedback';

export default Collection_Base.extend({
    model: Model_Feedback,

    sort_by: 'id',
    sort_order: 'desc',

    search_count: 0,
    workflow_count: {},

    polling_timer: null,

    comparator: function(a, b) {
        if (this.sort_by === 'due_date' && this.sort_order === 'asc') {
            // Only apply this custom sorting for 'due_date' in 'asc' order
            // The order is '0' comes last, then sort by ascending due_date
            var a_due_date = a.get('due_date');
            var b_due_date = b.get('due_date');

            // Sort such that due_date = 0 comes last
            if (a_due_date === 0 && b_due_date !== 0) return 1;
            if (b_due_date === 0 && b_due_date !== 0) return -1;

            // Otherwise, sort by ascending due_date
            return a_due_date - b_due_date;
        } else {
            var sort_by = a.has(this.sort_by) ? this.sort_by : 'id';

            if (this.sort_order === 'desc') {
                if (a.get(sort_by) === b.get(sort_by)) {
                    return a.id >= b.id ? -1 : 1; // always sort by id desc
                } else {
                    return a.get(sort_by) > b.get(sort_by) ? -1 : 1;
                }
            } else {
                if (a.get(sort_by) === b.get(sort_by)) {
                    return a.id >= b.id ? -1 : 1; // always sort by id desc
                } else {
                    return a.get(sort_by) < b.get(sort_by) ? -1 : 1;
                }
            }
        }
    },

    sortBy: function(sort_by, sort_order) {
        switch (sort_by) {
            case 'create':
                sort_by = 'time';
                break;
            case 'update':
                sort_by = 'last_update_time';
                break;
            case 'due_date':
                sort_by = 'due_date';
                break;
        }

        this.sort_by    = sort_by;
        this.sort_order = sort_order || 'desc';

        this.sort();
    },

    setSortBy: function(sort_by, sort_order) {
        switch (sort_by) {
            case 'create':
                sort_by = 'time';
                break;
            case 'update':
                sort_by = 'last_update_time';
                break;
            case 'due_date':
                sort_by = 'due_date';
                break;
        }

        this.sort_by    = sort_by;
        this.sort_order = sort_order || 'desc';
    },

    setSearchCount: function(count) {
        this.search_count = count;
    },

    startPolling: function() {
        if (this.polling_timer) {
            clearInterval(this.polling_timer);
        }
        this.polling_timer = setInterval(() => {
            var ids = this.getPolingIds();
            if (!ids.length) {
                this.stopPolling();
                return;
            }
            Cache.app.request({
                action: 'feedback/getAttributes',
                data: {ids},
                success: (response) => {
                    this.onPollingSuccess(response);
                }
            });
        }, 8000);
    },
    stopPolling: function() {
        if (this.polling_timer) {
            clearInterval(this.polling_timer);
        }
        this.polling_timer = null;
    },
    onPollingSuccess: function(res) {
        for (var feedback_data of res) {
            var model = Cache.feedback.get(feedback_data.id);
            if (!model) {
                continue;
            }
            model.set(feedback_data);
        }
    },
    getPolingIds: function() {
        var integrations = ['jira_url', 'clickup_url', 'wrike_url', 'azure_devops_url', 'teamwork_url', 'trello_url', 'basecamp_url', 'asana_url', 'monday_url', 'zendesk_url', 'github_url', 'gitlab_url', 'linear_url', 'notion_url'];
        var feedback_ids = [];
        this.each((model) => {
            if (integrations.filter((item) => model.get(item) === 'processing').length) {
                feedback_ids.push(model.id);
            }
        });
        return feedback_ids;
    },
});